import React, { useState, useEffect, useRef } from "react";
import "./ImageSlider.css";

const originalImages = [
 "/assets/banner/P1.png",
 "/assets/banner/P2.png",
  "/assets/banner/P3.png",
  "/assets/banner/P4.png",
  "/assets/banner/P5.png",
  "/assets/banner/P6.png",
   "/assets/banner/P1.png",
 "/assets/banner/P2.png",
  "/assets/banner/P3.png",
  "/assets/banner/P4.png",
  "/assets/banner/P5.png",
  "/assets/banner/P6.png",
   "/assets/banner/P1.png",
 "/assets/banner/P2.png",
  "/assets/banner/P3.png",
  "/assets/banner/P4.png",
  "/assets/banner/P5.png",
  "/assets/banner/P6.png",
   "/assets/banner/P1.png",
 "/assets/banner/P2.png",
  "/assets/banner/P3.png",
  "/assets/banner/P4.png",
  "/assets/banner/P5.png",
  "/assets/banner/P6.png",
   "/assets/banner/P1.png",
 "/assets/banner/P2.png",
  "/assets/banner/P3.png",
  "/assets/banner/P4.png",
  "/assets/banner/P5.png",
  "/assets/banner/P6.png",
   "/assets/banner/P1.png",
 "/assets/banner/P2.png",
  "/assets/banner/P3.png",
  "/assets/banner/P4.png",
  "/assets/banner/P5.png",
  "/assets/banner/P6.png",
   "/assets/banner/P1.png",
 "/assets/banner/P2.png",
  "/assets/banner/P3.png",
  "/assets/banner/P4.png",
  "/assets/banner/P5.png",
  "/assets/banner/P6.png",
   "/assets/banner/P1.png",
 "/assets/banner/P2.png",
  "/assets/banner/P3.png",
  "/assets/banner/P4.png",
  "/assets/banner/P5.png",
  "/assets/banner/P6.png",
   "/assets/banner/P1.png",
 "/assets/banner/P2.png",
  "/assets/banner/P3.png",
  "/assets/banner/P4.png",
  "/assets/banner/P5.png",
  "/assets/banner/P6.png",
   "/assets/banner/P1.png",
 "/assets/banner/P2.png",
  "/assets/banner/P3.png",
  "/assets/banner/P4.png",
  "/assets/banner/P5.png",
  "/assets/banner/P6.png",
   "/assets/banner/P1.png",
 "/assets/banner/P2.png",
  "/assets/banner/P3.png",
  "/assets/banner/P4.png",
  "/assets/banner/P5.png",
  "/assets/banner/P6.png",
   "/assets/banner/P1.png",
 "/assets/banner/P2.png",
  "/assets/banner/P3.png",
  "/assets/banner/P4.png",
  "/assets/banner/P5.png",
  "/assets/banner/P6.png",
   "/assets/banner/P1.png",
 "/assets/banner/P2.png",
  "/assets/banner/P3.png",
  "/assets/banner/P4.png",
  "/assets/banner/P5.png",
  "/assets/banner/P6.png",
   "/assets/banner/P1.png",
 "/assets/banner/P2.png",
  "/assets/banner/P3.png",
  "/assets/banner/P4.png",
  "/assets/banner/P5.png",
  "/assets/banner/P6.png",
   "/assets/banner/P1.png",
 "/assets/banner/P2.png",
  "/assets/banner/P3.png",
  "/assets/banner/P4.png",
  "/assets/banner/P5.png",
  "/assets/banner/P6.png",
   "/assets/banner/P1.png",
 "/assets/banner/P2.png",
  "/assets/banner/P3.png",
  "/assets/banner/P4.png",
  "/assets/banner/P5.png",
  "/assets/banner/P6.png",  
];

const ImageSlider = () => {
  const [current, setCurrent] = useState(0);
  const [itemsPerSlide, setItemsPerSlide] = useState(3);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const sliderRef = useRef(null);

  // Duplicate images for infinite effect
  const images = [...originalImages, ...originalImages,...originalImages,...originalImages,...originalImages,...originalImages,...originalImages,...originalImages];

  // Update items per slide dynamically
  useEffect(() => {
    const updateItems = () => {
      const newItemsPerSlide =
        window.innerWidth < 640 ? 1 : window.innerWidth < 1024 ? 2 : 3;
      setItemsPerSlide(newItemsPerSlide);
      setCurrent(0);
    };

    updateItems();
    window.addEventListener("resize", updateItems);
    return () => window.removeEventListener("resize", updateItems);
  }, []);

  // Auto-slide every 2s
  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 2000);
    return () => clearInterval(timer);
  }, [itemsPerSlide]);

  const nextSlide = () => {
    setCurrent((prev) => prev + 1);
  };

  // Watch for reset when reaching cloned end
  useEffect(() => {
    if (current === originalImages.length) {
      // disable transition, jump instantly back
      setTimeout(() => {
        setIsTransitioning(false);
        setCurrent(0);
      }, 300);
    } else {
      setIsTransitioning(true);
    }
  }, [current]);

  return (
    <div className="slider-container">
      <div
        ref={sliderRef}
        className="slider-wrapper"
        style={{
          transform: `translateX(-${current * (100 / itemsPerSlide)}%)`,
          transition: isTransitioning ? "transform 0.3s ease-in-out" : "none",
        }}
      >
        {images.map((src, idx) => (
          <div
            className="slide"
            key={`${src}-${idx}`}
            style={{ flex: `0 0 ${100 / itemsPerSlide}%` }}
          >
            <img src={src} alt={`slide-${idx}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageSlider;
